import { injectable } from 'tsyringe';
import { HttpClientApi } from '@/modules/http-client/public/api';

import type { WhatsAppSenderRepository } from '@/modules/settings/domain/channels/WhatsAppSenderRepository';
import type { WhatsAppSender } from '@/modules/settings/domain/channels/WhatsAppSender';
import type { HttpWhatsAppSender } from '@/modules/settings/adapters/channels/HttpWhatsAppSender';
import { HttpWhatsAppSenderFactory } from '@/modules/settings/adapters/channels/HttpWhatsAppSenderFactory';

const SENDERS_URL = '/api/v0/facility/{facilityId}/whatsapp/senders';

@injectable()
export class HttpWhatsAppSenderRepository implements WhatsAppSenderRepository {
  constructor(private readonly httpClient: HttpClientApi) {}

  async get(): Promise<WhatsAppSender | null> {
    // A facility without a sender answers 204, which axios surfaces as an empty body.
    const data = await this.httpClient.get<HttpWhatsAppSender | ''>(SENDERS_URL);

    return data ? HttpWhatsAppSenderFactory.make(data) : null;
  }

  async refresh(): Promise<WhatsAppSender | null> {
    const data = await this.httpClient.post<HttpWhatsAppSender | ''>(`${SENDERS_URL}/refresh`, {});

    return data ? HttpWhatsAppSenderFactory.make(data) : null;
  }

  async register(wabaId: string, phoneNumber: string): Promise<WhatsAppSender> {
    const data = await this.httpClient.post<HttpWhatsAppSender>(SENDERS_URL, {
      wabaId,
      phoneNumber,
      numberSource: 'bring_your_own',
    });

    return HttpWhatsAppSenderFactory.make(data);
  }

  async verify(code: string): Promise<WhatsAppSender> {
    const data = await this.httpClient.post<HttpWhatsAppSender>(`${SENDERS_URL}/verification`, {
      code,
    });

    return HttpWhatsAppSenderFactory.make(data);
  }
}
